// Centralised translations for Artful Contemporary (English + German)
// Non-translated assets (images, URLs, phone numbers) remain in /data/content.js

const en = {
  nav: {
    home: "Home",
    exhibitions: "Our Exhibitions",
    venues: "Our Venues",
    services: "Our Services",
    concepts: "Our Concepts",
    shop: "Shop",
    contact: "Contact",
  },
  common: {
    explore: "Explore Exhibitions",
    aboutArtful: "About Artful",
    visitNow: "Visit Now",
    learnMore: "Learn More",
    touringExhibition: "Touring Exhibition",
    discoverAllExhibitions: "Discover All Exhibitions",
    scrollToDiscover: "SCROLL TO DISCOVER",
    backToHome: "Home",
  },
  hero: [
    { eyebrow: "Starting October 22", title: "Banksy Street Is The Museum", cta: "Explore Exhibition" },
    { eyebrow: "Starting September 11", title: "House of Banksy Stuttgart", cta: "Explore Exhibition" },
    { eyebrow: "Artful Contemporary", title: "Where Art Becomes Experience" },
    { eyebrow: "Now on view", title: "The World of Banksy" },
    { eyebrow: "10 venues worldwide", title: "An International Stage for Contemporary Art" },
  ],
  cookie: {
    title: "We value your privacy",
    text:
      "We use cookies and tracking technologies (Google Analytics, Google Tag Manager, Meta Pixel) to analyse traffic and improve your experience. Tracking only runs with your consent.",
    accept: "Accept",
    decline: "Decline",
    privacy: "Privacy Policy",
  },
  countdown: {
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
  },
  about: {
    eyebrow: "About Us",
    title1: "Artful",
    title2: "Contemporary",
    p1:
      "At Artful Events, we create transformative art experiences that leave a lasting impact. By offering services such as Original Art Concepts, Art Exhibition Management, Art Event Management, and Artist Management, we are the trusted partner for those seeking to inspire, engage, and innovate.",
    p2:
      "Collaborating with renowned artists and leading organizations in the art world, we design experiences that set new industry standards. Together, let's create something extraordinary.",
    quote: "Let's get Artful.",
  },
  exhibitionsTeaser: {
    eyebrow: "Our Exhibitions",
    title1: "Curated",
    title2: "Worldwide",
    body:
      "From Amsterdam to New York — ten venues, one shared passion: bringing transformative contemporary art to broad audiences.",
    cta: "See All Exhibitions",
  },
  onView: {
    eyebrow: "Our Exhibitions",
    title1: "Currently",
    title2: "on view",
  },
  stats: {
    eyebrow: "Since 2018",
    title1: "Curated",
    title2: "Impact",
    labels: ["Visitors", "Cities", "Exhibitions"],
  },
  history: {
    eyebrow: "History of Artful",
    title1: "Milestones",
    title2: "Achieved",
    intro:
      "Since its inception, Artful has been dedicated to fostering meaningful connections between art enthusiasts, artists, and exceptional artworks through expertise and innovation.",
    futureEyebrow: "Future Outlook",
    futureBody:
      "Artful Events will keep strengthening its network of permanent exhibition venues as a core pillar. Selective, concept-driven touring exhibitions will introduce new brands and formats. Long-term goal: to become a leading global platform for permanent cultural venues and innovative touring exhibitions.",
    items: [
      {
        year: "2018",
        title: "Foundation & Vision",
        body:
          "Artful Events was founded as a company focused on cultural events and exhibition production. From the start, the vision was to create and operate large-scale, internationally relevant contemporary art exhibitions. In the same year, the first permanent Banksy Museum opened in Paris, launching the innovative and experience-driven exhibition concept.",
      },
      {
        year: "2023",
        title: "European Network Growth & Diversification",
        body:
          "New permanent Banksy Museums opened across Europe in Barcelona, Spain (October 2023), Lisbon, Portugal (May 2023), Brussels, Belgium (December 2023), and Krakow, Poland (permanent Banksy Museum — December 2023). A strategic partnership with Body Worlds began, marking an important step in portfolio diversification.",
      },
      {
        year: "2024",
        title: "Consolidation of Permanent Museums & Touring Scale",
        body:
          "Touring exhibitions opened in Naples, Italy, and Budapest, Hungary. New permanent Banksy Museums were launched in Madrid, Spain, Brussels, Belgium, and New York, USA — one of our most significant steps toward a truly global vision.",
      },
      {
        year: "2025",
        title: "Network Expansion & Major Touring Projects",
        body:
          "A new permanent Banksy Museum opened in Amsterdam, Netherlands. Large-scale touring exhibitions launched in Milan Certosa, Düsseldorf (May 2025 – March 2026), and Dortmund (December 2025), Germany.",
      },
      {
        year: "2026+",
        title: "Strategic Development & New Horizons",
        body:
          "A brand-new permanent exhibition venue opens in Milan Certosa, serving as a strategic platform for future collaborations and large-scale productions. Future Banksy projects will focus increasingly on permanent exhibitions, while new independent concepts expand the touring portfolio.",
      },
    ],
  },
  testimonials: {
    eyebrow: "Visitor Reviews",
    title1: "Voices from",
    title2: "Our Visitors",
    visitorLabel: "Visitor",
  },
  newsletter: {
    eyebrow: "Join the Artful Community",
    title1: "Museum",
    title2: "News",
    body:
      "Sign up to be the first to hear about our latest exhibitions, exclusive updates and fresh perspectives on the art world. Get early access to new releases, exciting products and insider stories.",
    tagline: "Join our community and never miss an inspiring moment.",
    name: "Name",
    email: "Email",
    phone: "Phone (optional)",
    cta: "Subscribe Now",
    submitting: "Subscribing…",
    success: "You're in. Welcome to the Artful community.",
    errorRequired: "Please enter your name and email.",
    errorGeneric: "Subscription failed. Please try again.",
    errorConsent: "Please accept both consent checkboxes to continue.",
    consentNewsletter:
      "I would like to subscribe to the Artful newsletter to receive updates about new exhibitions, events, exclusive offers, and art news. I consent to my email address being used for this purpose.*",
    consentDataProcessing:
      "I consent to the processing and storage of my personal data for the purposes mentioned above. I can withdraw this consent at any time.",
    consentPrivacyLink: "Privacy Policy",
  },
  shop: {
    eyebrow: "Our Products",
    title1: "Shop the",
    title2: "Art",
    body:
      "Explore exclusive merchandise inspired by our exhibitions. Find unique pieces that bring the art experience home.",
    cta: "Visit Shop",
    productCaption: "Artful · Merchandise",
  },
  contactStrip: {
    eyebrow: "Get in Touch",
    title: "Contact",
    body:
      "Ready to host a show-stopping art experience? Let's collaborate to elevate your brand and engage your audience. Contact us today and let's get Artful.",
    cta: "Contact Now",
    address: "Address",
    phone: "Phone",
    email: "Email",
  },
  pageHero: {
    home: "Home",
  },
  pages: {
    about: {
      eyebrow: "Our Vision",
      title: "Artful Contemporary",
      subtitle:
        "Comprehensive management solutions for today's most influential artists and artworks.",
      sectionEyebrow: "Our Story",
      heading1: "Making art",
      heading2: "meaningful",
      heading3: "and accessible.",
      paragraphs: [
        "Artful Contemporary provides comprehensive management solutions for today's most influential artists and artworks, ensuring their lasting impact on the global cultural landscape.",
        "Since our establishment in 2017, we at Artful Events have dedicated ourselves to providing the highest quality art exhibitions, innovative art concepts, art event management, and artist management services across Europe and the Middle East. With our commitment to excellence, we have transformed art and its works into prestigious exhibitions at extraordinary venues, positioning ourselves as a trusted partner in the art industry.",
        "Our mission is to make art meaningful and accessible, enhance artists' visibility, and create awareness by fostering emotional connections through the experiences we create with their works. Through original concepts like The World of Banksy, we bring to life captivating and impactful exhibitions that leave a lasting impression and make a statement.",
        "At Artful Events, we design experiences that stir emotions, intellect, and the senses, connecting audiences with the artist and their works, and enhancing the value of every art event and exhibition. Our talented team of curators, designers, and event planners work tirelessly to produce unforgettable exhibitions that captivate and inspire.",
        "We design our exhibitions from end to end — concept creation, venue design, artwork selection and reproduction, sales strategy, marketing, and most importantly, ensuring visitor contentment. We continuously refresh our exhibitions to keep the interest alive.",
        "Focused on building strong partnerships fueled by a passion for art, we offer bespoke solutions customized to each client's unique needs. From art exhibitions to event management, we are here to elevate your brand and create unforgettable art experiences.",
      ],
      visitEyebrow: "Find The Artful",
      visitTitle1: "Visit",
      visitTitle2: "Us",
      meetTeam: "Meet Our Team",
    },
    exhibitions: {
      eyebrow: "Global Showcases",
      title: "Our Exhibitions",
      subtitle:
        "Explore our past, current and upcoming exhibitions, and see what we've created in the world of art.",
      currentEyebrow: "Touring & Permanent",
      currentTitle1: "Currently",
      currentTitle2: "On View",
      currentBody:
        "10 venues across Europe and the United States. A growing global network of permanent museum experiences.",
      pastEyebrow: "Exhibition Archive",
      pastTitle1: "Past",
      pastTitle2: "Exhibitions",
    },
    services: {
      eyebrow: "What We Offer",
      title: "Our Services",
      subtitle:
        "End-to-end management for exhibitions, original concepts, artist representation and cultural events.",
      items: [
        { n: "01", title: "Original Art Concepts", body: "We design and develop original concepts that transform spaces into immersive experiences. Each idea is tailored to inspire and reflect both the artist's vision and the audience's expectations." },
        { n: "02", title: "Art Exhibition Management", body: "From concept creation to opening day, we deliver end-to-end exhibition production: design, logistics, partnerships, marketing and operations." },
        { n: "03", title: "Art Event Management", body: "Premieres, openings, gala dinners, private viewings — we craft memorable cultural events that elevate brand and artist visibility." },
        { n: "04", title: "Touring Exhibitions", body: "We design and operate large-scale touring exhibitions that travel across cities and countries, reaching new audiences globally." },
        { n: "05", title: "Artist Management", body: "We offer professional support to guide artists' careers, facilitate their participation in international projects, and showcase their works worldwide." },
        { n: "06", title: "Project & Partnership", body: "Artful builds meaningful partnerships with leading institutions, brands, and artists to create innovative projects that shape the contemporary art landscape." },
      ],
    },
    concepts: {
      eyebrow: "Impactful Collaborations",
      title: "Our Concepts",
      subtitle:
        "Artful builds meaningful partnerships with leading institutions, brands, and artists to create innovative projects that shape the contemporary art landscape.",
      items: [
        { title: "The World of Banksy", subtitle: "Our Original Concept", body: "Through The World of Banksy, we aim to bring the artist's message to a wider audience by offering art lovers the opportunity to discover Banksy's works from many different places around the world, all in one location. In addition to original works, we collaborate with local graffiti artists to recreate Banksy's artistic vision. This concept explores powerful themes such as war, peace, capitalism, consumerism, and individualism — stimulating visitors' thoughts and emotions." },
        { title: "Andy Warhol: Neo-Popism", subtitle: "Coming Soon", body: "The iconic artist of the 20th century, Andy Warhol's Pop Art legacy is reinterpreted through the lens of the social media age and Neo-Pop aesthetics in this powerful exhibition. A bold experience centered on color, repetition, and fame. Coming soon!" },
        { title: "Cofo", subtitle: "Collaboration Partner", body: "In collaboration with Cofo, we proudly opened the House of Banksy exhibition in Dortmund. This exciting partnership brings a fresh perspective to contemporary art, successfully presenting Banksy's powerful works in a unique and striking setting." },
      ],
    },
    team: {
      eyebrow: "Our Team",
      title: "Meet The Team",
      subtitle:
        "A passionate group of curators, designers, producers and storytellers behind every Artful experience.",
    },
    venues: {
      eyebrow: "Our Venues",
      title: "Our Venues",
      subtitle:
        "Versatile destinations designed to evolve with every event — and give visitors new reasons to return.",
      milanoEyebrow: "Milano · Certosa District",
      milanoTitle1: "Department 184",
      milanoTitle2: "Your Third Place",
      milanoP1:
        "As part of our growing portfolio of venues, we proudly manage and operate Department 184, a unique multi-purpose destination located in the heart of the Milano Certosa District.",
      milanoP2:
        "Developed within the former Sandvik industrial site, the venue offers over 3,000 sqm of flexible indoor space, complemented by an outdoor area overlooking the newly created 10,000 sqm public park. Combining industrial character with a contemporary vision, Department 184 has been designed as a dynamic hub for culture, entertainment, food, and community.",
      pillarsEyebrow: "Three Concepts · One Roof",
      pillarsTitle1: "A Larger",
      pillarsTitle2: "Ecosystem",
      pillarsIntro:
        "Under one roof, the venue brings together three complementary concepts. Each area maintains its own identity while contributing to an ecosystem that encourages creativity, social interaction, and memorable experiences.",
      pillars: [
        { n: "01", title: "Event Space", body: "Expansive, adaptable halls for art exhibitions, fashion shows, product launches, concerts and corporate gatherings." },
        { n: "02", title: "Food Dept 184", body: "A culinary destination where chefs, residents and visitors converge — from corporate lunches to refined private dinners." },
        { n: "03", title: "Club Dept 184", body: "After-hours culture: DJ sets, live performances and immersive nights set against industrial architecture." },
      ],
      highlightsEyebrow: "The Venue at a Glance",
      highlightsTitle1: "Built for",
      highlightsTitle2: "every event",
      highlights: [
        { value: "3,000", suffix: " sqm", label: "Indoor Space" },
        { value: "10,000", suffix: " sqm", label: "Public Park Outlook" },
        { value: "3", suffix: " in 1", label: "Concept Under One Roof" },
      ],
      designedEyebrow: "Designed to Host",
      designedP1:
        "The venue is designed to host a wide range of events, including art exhibitions, cultural and corporate events, concerts, DJ sets, fashion shows, markets, product launches, workshops, photo shoots, private celebrations, and corporate lunches and dinners.",
      designedP2:
        "With its adaptable layout, high ceilings, and distinctive atmosphere, Department 184 represents Artful Events' vision of creating versatile destinations that evolve with every event and offer visitors new reasons to return.",
      caption: "Department 184 · Former Sandvik Industrial Site · Milano",
    },
    faq: {
      eyebrow: "Need Help",
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know before visiting an Artful exhibition.",
      items: [
        { q: "Where are Artful exhibitions located?", a: "Artful operates permanent and touring exhibitions across Europe and the United States — including Amsterdam, Barcelona, Brussels, Krakow, Lisbon, Madrid, New York, Paris, Prague, and Dortmund." },
        { q: "Do I need to book tickets in advance?", a: "We recommend booking in advance via each venue's official ticketing page (linked from the Our Exhibitions page) to guarantee entry, especially on weekends and during holidays." },
        { q: "Are the exhibitions family friendly?", a: "Yes — most of our exhibitions are suitable for all ages. We offer educational programs, family tours and special workshops for children." },
        { q: "Can I take photographs inside the exhibition?", a: "Photography for personal use is generally welcome. Tripods, flash and commercial photography require prior approval." },
        { q: "Do you offer group or school visits?", a: "Absolutely. We provide guided tours and educational programs for groups, schools and corporate visits. Please contact us to plan a tailored visit." },
        { q: "How can my brand or institution collaborate with Artful?", a: "We partner with brands, museums and institutions on co-productions, sponsorships and bespoke cultural projects. Get in touch via our Contact page to start a conversation." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's Get In Touch",
      subtitle:
        "Send us a message — partnerships, press, ticketing or anything else.",
      formEyebrow: "Send a Message",
      formTitle: "Write to us",
      name: "Name *",
      email: "Email *",
      phone: "Phone",
      message: "Message *",
      cta: "Send Message",
      submitting: "Sending…",
      success: "Thank you. We'll be in touch shortly.",
      infoEyebrow: "Visit Us",
      infoTitle: "Our Office",
    },
    imprint: {
      eyebrow: "Legal",
      title: "Imprint",
      subtitle: "Legal website operator identification.",
    },
    privacy: {
      eyebrow: "Legal",
      title: "Privacy Policy",
      subtitle: "Data protection declaration.",
    },
  },
  footer: {
    columns: {
      about: "About Us",
      support: "Support",
      follow: "Follow Us",
    },
    links: {
      about: "About",
      imprint: "Imprint",
      privacy: "Privacy Policy",
      contact: "Contact",
      faq: "FAQ",
    },
    tagline:
      "Transformative art experiences. Curated exhibitions, original concepts and partnerships across Europe, the Middle East and the United States.",
    closing: "Let's get Artful. Contemporary art, world-class venues, lasting impact.",
    crafted: "Crafted with passion · Neuss, Germany",
    copyright: "All rights reserved.",
  },
};

const de = {
  nav: {
    home: "Home",
    exhibitions: "Ausstellungen",
    venues: "Locations",
    services: "Leistungen",
    concepts: "Konzepte",
    shop: "Shop",
    contact: "Kontakt",
  },
  common: {
    explore: "Ausstellungen entdecken",
    aboutArtful: "Über Artful",
    visitNow: "Jetzt besuchen",
    learnMore: "Mehr erfahren",
    touringExhibition: "Wanderausstellung",
    discoverAllExhibitions: "Alle Ausstellungen entdecken",
    scrollToDiscover: "ZUM ENTDECKEN SCROLLEN",
    backToHome: "Startseite",
  },
  hero: [
    { eyebrow: "Ab 22. Oktober", title: "Banksy Street Is The Museum", cta: "Ausstellung entdecken" },
    { eyebrow: "Ab 11. September", title: "House of Banksy Stuttgart", cta: "Ausstellung entdecken" },
    { eyebrow: "Artful Contemporary", title: "Wo Kunst zum Erlebnis wird" },
    { eyebrow: "Jetzt zu sehen", title: "The World of Banksy" },
    { eyebrow: "10 Standorte weltweit", title: "Eine internationale Bühne für zeitgenössische Kunst" },
  ],
  cookie: {
    title: "Wir respektieren Ihre Privatsphäre",
    text:
      "Wir verwenden Cookies und Tracking-Technologien (Google Analytics, Google Tag Manager, Meta Pixel), um die Nutzung zu analysieren und Ihr Erlebnis zu verbessern. Tracking erfolgt nur mit Ihrer Einwilligung.",
    accept: "Akzeptieren",
    decline: "Ablehnen",
    privacy: "Datenschutzerklärung",
  },
  countdown: {
    days: "Tage",
    hours: "Stunden",
    minutes: "Minuten",
    seconds: "Sekunden",
  },
  about: {
    eyebrow: "Über uns",
    title1: "Artful",
    title2: "Contemporary",
    p1:
      "Bei Artful Events entwickeln wir außergewöhnliche Kunst- und Kulturerlebnisse, die Menschen begeistern und nachhaltig in Erinnerung bleiben. Mit unseren Leistungen in den Bereichen Ausstellungskonzepte, Ausstellungsmanagement, Eventmanagement und Künstlermanagement begleiten wir Unternehmen, Institutionen und Partner von der ersten Idee bis zur erfolgreichen Umsetzung.",
    p2:
      "Gemeinsam mit renommierten Künstlern und führenden Akteuren der internationalen Kunstszene realisieren wir Projekte, die Menschen verbinden, Räume neu denken und bleibende Eindrücke schaffen. Lassen Sie uns gemeinsam etwas Außergewöhnliches verwirklichen.",
    quote: "Let's get Artful.",
  },
  exhibitionsTeaser: {
    eyebrow: "Unsere Ausstellungen",
    title1: "Kuratieren",
    title2: "Weltweit",
    body:
      "Von Amsterdam bis New York, 10 Standorte, eine gemeinsame Leidenschaft: transformative zeitgenössische Kunst einem breiten Publikum zugänglich machen.",
    cta: "Alle Ausstellungen ansehen",
  },
  onView: {
    eyebrow: "Unsere Ausstellungen",
    title1: "Aktuell",
    title2: "zu sehen",
  },
  stats: {
    eyebrow: "Seit 2018",
    title1: "Kuratierte",
    title2: "Erlebnisse",
    labels: ["Besucher", "Städte", "Ausstellungen"],
  },
  history: {
    eyebrow: "Geschichte von Artful",
    title1: "Erreichte",
    title2: "Meilensteine",
    intro:
      "Seit unserer Gründung widmet sich Artful der Förderung bedeutungsvoller Verbindungen zwischen Kunstliebhabern, Künstlern und außergewöhnlichen Kunstwerken — durch Fachkompetenz und Innovation.",
    futureEyebrow: "Zukunftsausblick",
    futureBody:
      "Artful Events wird sein Netzwerk dauerhafter Ausstellungsorte als zentrale Säule weiter ausbauen. Ausgewählte, konzeptgetriebene Wanderausstellungen werden neue Marken und Formate einführen. Langfristiges Ziel: eine führende globale Plattform für permanente Kulturorte und innovative Wanderausstellungen zu werden.",
    items: [
      {
        year: "2018",
        title: "Gründung & Vision",
        body:
          "Artful Events wurde als Unternehmen für Kulturveranstaltungen und Ausstellungsproduktion gegründet. Von Beginn an war die Vision, großformatige, international relevante zeitgenössische Kunstausstellungen zu schaffen und zu betreiben. Im selben Jahr eröffnete in Paris das erste permanente Banksy Museum — der Auftakt für unser innovatives, erlebnisorientiertes Ausstellungskonzept.",
      },
      {
        year: "2023",
        title: "Wachstum & Diversifizierung in Europa",
        body:
          "Neue permanente Banksy Museums wurden in Barcelona, Spanien (Oktober 2023), Lissabon, Portugal (Mai 2023), Brüssel, Belgien (Dezember 2023) und Krakau, Polen (permanentes Banksy Museum — Dezember 2023) eröffnet. Eine strategische Partnerschaft mit Body Worlds begann und markierte einen wichtigen Schritt der Portfolio-Diversifizierung.",
      },
      {
        year: "2024",
        title: "Konsolidierung permanenter Museen & Tourneeausbau",
        body:
          "Wanderausstellungen eröffneten in Neapel, Italien, und Budapest, Ungarn. Neue permanente Banksy Museums entstanden in Madrid, Spanien, Brüssel, Belgien, und New York, USA — einer unserer bedeutendsten Schritte hin zu einer wahrhaft globalen Vision.",
      },
      {
        year: "2025",
        title: "Netzwerkerweiterung & große Tourneeprojekte",
        body:
          "Ein neues permanentes Banksy Museum eröffnete in Amsterdam, Niederlande. Großformatige Wanderausstellungen starteten in Mailand Certosa, Düsseldorf (Mai 2025 – März 2026) und Dortmund (Dezember 2025), Deutschland.",
      },
      {
        year: "2026+",
        title: "Strategische Entwicklung & neue Horizonte",
        body:
          "Ein brandneuer permanenter Ausstellungsort eröffnet in Mailand Certosa und wird als strategische Plattform für künftige Kollaborationen und Großproduktionen dienen. Künftige Banksy-Projekte werden sich verstärkt auf permanente Ausstellungen konzentrieren, während neue, eigenständige Konzepte das Tournee-Portfolio erweitern.",
      },
    ],
  },
  testimonials: {
    eyebrow: "Besucherstimmen",
    title1: "Stimmen unserer",
    title2: "Besucher",
    visitorLabel: "Besucher",
  },
  newsletter: {
    eyebrow: "Werden Sie Teil der Artful-Community",
    title1: "Museums-",
    title2: "News",
    body:
      "Melden Sie sich an, um als Erste von unseren neuesten Ausstellungen, exklusiven Updates und frischen Perspektiven aus der Kunstwelt zu erfahren. Erhalten Sie frühzeitigen Zugang zu Neuheiten, spannenden Produkten und Insider-Geschichten.",
    tagline: "Werden Sie Teil unserer Community und verpassen Sie keinen inspirierenden Moment.",
    name: "Name",
    email: "E-Mail",
    phone: "Telefon (optional)",
    cta: "Jetzt abonnieren",
    submitting: "Wird gesendet…",
    success: "Sie sind dabei. Willkommen in der Artful-Community.",
    errorRequired: "Bitte geben Sie Name und E-Mail ein.",
    errorGeneric: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
    errorConsent: "Bitte bestätigen Sie beide Einwilligungen, um fortzufahren.",
    consentNewsletter:
      "Ich möchte den Artful-Newsletter abonnieren, um Informationen über neue Ausstellungen, Veranstaltungen, exklusive Angebote und Kunstmeldungen zu erhalten. Ich bin damit einverstanden, dass meine E-Mail-Adresse zu diesem Zweck verwendet wird.*",
    consentDataProcessing:
      "Ich bin damit einverstanden, dass meine personenbezogenen Daten zu den oben genannten Zwecken verarbeitet und gespeichert werden. Ich kann diese Einwilligung jederzeit widerrufen.",
    consentPrivacyLink: "Datenschutzerklärung",
  },
  shop: {
    eyebrow: "Unsere Produkte",
    title1: "Kunst",
    title2: "shoppen",
    body:
      "Entdecken Sie exklusive Merchandise, inspiriert von unseren Ausstellungen. Einzigartige Stücke, die das Kunsterlebnis nach Hause bringen.",
    cta: "Zum Shop",
    productCaption: "Artful · Merchandise",
  },
  contactStrip: {
    eyebrow: "Kontakt aufnehmen",
    title: "Kontakt",
    body:
      "Bereit, ein außergewöhnliches Kunsterlebnis zu inszenieren? Lassen Sie uns zusammenarbeiten, um Ihre Marke zu heben und Ihr Publikum zu begeistern. Kontaktieren Sie uns — let's get Artful.",
    cta: "Jetzt Kontakt aufnehmen",
    address: "Adresse",
    phone: "Telefon",
    email: "E-Mail",
  },
  pageHero: {
    home: "Startseite",
  },
  pages: {
    about: {
      eyebrow: "Unsere Vision",
      title: "Artful Contemporary",
      subtitle:
        "Umfassende Management-Lösungen für die einflussreichsten Künstler und Kunstwerke unserer Zeit.",
      sectionEyebrow: "Unsere Geschichte",
      heading1: "Kunst",
      heading2: "bedeutsam",
      heading3: "und zugänglich machen.",
      paragraphs: [
        "Artful Contemporary bietet umfassende Management-Lösungen für die einflussreichsten Künstler und Kunstwerke von heute und sichert ihre nachhaltige Wirkung in der globalen Kulturlandschaft.",
        "Seit unserer Gründung 2017 widmen wir uns bei Artful Events der Bereitstellung hochwertiger Kunstausstellungen, innovativer Kunstkonzepte sowie Event- und Künstlermanagement-Leistungen in ganz Europa und im Nahen Osten. Mit unserem Anspruch auf Exzellenz verwandeln wir Kunst und ihre Werke in prestigeträchtige Ausstellungen an außergewöhnlichen Orten und positionieren uns als vertrauensvoller Partner der Kunstbranche.",
        "Unsere Mission ist es, Kunst bedeutsam und zugänglich zu machen, die Sichtbarkeit von Künstlern zu erhöhen und durch die Erlebnisse, die wir mit ihren Werken schaffen, emotionale Verbindungen herzustellen. Mit Original-Konzepten wie The World of Banksy bringen wir fesselnde und wirkungsvolle Ausstellungen zum Leben, die nachhaltig beeindrucken.",
        "Bei Artful Events gestalten wir Erlebnisse, die Emotionen, Intellekt und Sinne ansprechen, das Publikum mit Künstler und Werk verbinden und den Wert jeder Kunstveranstaltung steigern. Unser talentiertes Team aus Kuratoren, Designern und Eventmanagern arbeitet unermüdlich daran, unvergessliche Ausstellungen zu produzieren.",
        "Wir gestalten unsere Ausstellungen von A bis Z — Konzeptentwicklung, Venue-Design, Auswahl und Reproduktion der Werke, Vertriebsstrategie, Marketing und vor allem die Zufriedenheit der Besucher. Wir aktualisieren unsere Ausstellungen kontinuierlich, um das Interesse lebendig zu halten.",
        "Mit Fokus auf starke Partnerschaften, getragen von einer Leidenschaft für Kunst, bieten wir maßgeschneiderte Lösungen für die individuellen Bedürfnisse jedes Kunden. Von Kunstausstellungen bis hin zu Eventmanagement — wir heben Ihre Marke hervor und schaffen unvergessliche Kunsterlebnisse.",
      ],
      visitEyebrow: "Artful finden",
      visitTitle1: "Besuchen Sie",
      visitTitle2: "uns",
      meetTeam: "Unser Team kennenlernen",
    },
    exhibitions: {
      eyebrow: "Globale Schauplätze",
      title: "Unsere Ausstellungen",
      subtitle:
        "Entdecken Sie unsere vergangenen, aktuellen und kommenden Ausstellungen und sehen Sie, was wir in der Kunstwelt geschaffen haben.",
      currentEyebrow: "Wander & Permanent",
      currentTitle1: "Aktuell",
      currentTitle2: "zu sehen",
      currentBody:
        "10 Standorte in Europa und den Vereinigten Staaten. Ein wachsendes globales Netzwerk permanenter Museumserlebnisse.",
      pastEyebrow: "Ausstellungsarchiv",
      pastTitle1: "Vergangene",
      pastTitle2: "Ausstellungen",
    },
    services: {
      eyebrow: "Was wir bieten",
      title: "Unsere Leistungen",
      subtitle:
        "Komplettmanagement für Ausstellungen, Originalkonzepte, Künstlervertretung und Kulturveranstaltungen.",
      items: [
        { n: "01", title: "Original-Kunstkonzepte", body: "Wir entwickeln Originalkonzepte, die Räume in immersive Erlebnisse verwandeln. Jede Idee wird maßgeschneidert — sie spiegelt die Vision des Künstlers und die Erwartungen des Publikums wider." },
        { n: "02", title: "Ausstellungsmanagement", body: "Von der Konzeption bis zum Eröffnungstag liefern wir Ausstellungsproduktionen aus einer Hand: Design, Logistik, Partnerschaften, Marketing und Betrieb." },
        { n: "03", title: "Eventmanagement", body: "Premieren, Eröffnungen, Gala-Dinner, Privat-Preview — wir kuratieren unvergessliche Kulturveranstaltungen, die die Sichtbarkeit von Marken und Künstlern erhöhen." },
        { n: "04", title: "Wanderausstellungen", body: "Wir konzipieren und betreiben großformatige Wanderausstellungen, die durch Städte und Länder reisen und weltweit neues Publikum erreichen." },
        { n: "05", title: "Künstlermanagement", body: "Wir bieten professionelle Unterstützung, um Karrieren von Künstlern zu begleiten, ihre Teilnahme an internationalen Projekten zu ermöglichen und ihre Werke weltweit zu präsentieren." },
        { n: "06", title: "Projekte & Partnerschaften", body: "Artful baut sinnvolle Partnerschaften mit führenden Institutionen, Marken und Künstlern auf, um innovative Projekte zu schaffen, die die zeitgenössische Kunstlandschaft prägen." },
      ],
    },
    concepts: {
      eyebrow: "Wirkungsvolle Kollaborationen",
      title: "Unsere Konzepte",
      subtitle:
        "Artful baut sinnvolle Partnerschaften mit führenden Institutionen, Marken und Künstlern auf, um innovative Projekte zu schaffen, die die zeitgenössische Kunstlandschaft prägen.",
      items: [
        { title: "The World of Banksy", subtitle: "Unser Originalkonzept", body: "Mit The World of Banksy bringen wir die Botschaft des Künstlers einem breiten Publikum näher — indem wir Kunstliebhabern die Möglichkeit geben, Banksys Werke aus vielen Orten der Welt an einem einzigen Standort zu entdecken. Neben Originalwerken arbeiten wir mit lokalen Graffiti-Künstlern zusammen, um Banksys künstlerische Vision nachzustellen. Das Konzept thematisiert Krieg, Frieden, Kapitalismus, Konsum und Individualismus — und regt Gedanken und Emotionen der Besucher an." },
        { title: "Andy Warhol: Neo-Popism", subtitle: "Bald verfügbar", body: "Der ikonische Künstler des 20. Jahrhunderts: Andy Warhols Pop-Art-Erbe wird durch die Linse des Social-Media-Zeitalters und Neo-Pop-Ästhetik in dieser kraftvollen Ausstellung neu interpretiert. Ein mutiges Erlebnis rund um Farbe, Wiederholung und Ruhm. Bald verfügbar!" },
        { title: "Cofo", subtitle: "Kollaborationspartner", body: "In Zusammenarbeit mit Cofo haben wir stolz die Ausstellung House of Banksy in Dortmund eröffnet. Diese spannende Partnerschaft bringt eine frische Perspektive in die zeitgenössische Kunst und präsentiert Banksys eindrucksvolle Werke in einem einzigartigen Rahmen." },
      ],
    },
    team: {
      eyebrow: "Unser Team",
      title: "Lernen Sie das Team kennen",
      subtitle:
        "Eine leidenschaftliche Gruppe aus Kuratoren, Designern, Produzenten und Storytellern hinter jedem Artful-Erlebnis.",
    },
    venues: {
      eyebrow: "Unsere Locations",
      title: "Unsere Locations",
      subtitle:
        "Vielseitige Orte, die sich mit jeder Veranstaltung weiterentwickeln — und Besuchern immer neue Gründe geben, wiederzukommen.",
      milanoEyebrow: "Mailand · Certosa District",
      milanoTitle1: "Department 184",
      milanoTitle2: "Ihr Dritter Ort",
      milanoP1:
        "Als Teil unseres wachsenden Portfolios an Veranstaltungsorten betreiben und führen wir Department 184 — eine einzigartige Multifunktions-Destination im Herzen des Mailänder Certosa-Viertels.",
      milanoP2:
        "Entwickelt auf dem ehemaligen Sandvik-Industrieareal, bietet die Location über 3.000 qm flexible Innenfläche, ergänzt durch einen Außenbereich mit Blick auf den neu geschaffenen 10.000 qm großen öffentlichen Park. Department 184 verbindet industriellen Charakter mit zeitgenössischer Vision und wurde als dynamischer Hub für Kultur, Entertainment, Food und Community konzipiert.",
      pillarsEyebrow: "Drei Konzepte · Ein Dach",
      pillarsTitle1: "Ein größeres",
      pillarsTitle2: "Ökosystem",
      pillarsIntro:
        "Unter einem Dach vereint die Location drei sich ergänzende Konzepte. Jeder Bereich behält seine eigene Identität und trägt zugleich zu einem Ökosystem bei, das Kreativität, soziale Interaktion und unvergessliche Erlebnisse fördert.",
      pillars: [
        { n: "01", title: "Event Space", body: "Weitläufige, anpassbare Hallen für Kunstausstellungen, Modenschauen, Produktlaunches, Konzerte und Firmenevents." },
        { n: "02", title: "Food Dept 184", body: "Eine kulinarische Destination, an der Köche, Anwohner und Besucher zusammenkommen — von Business-Lunches bis zu privaten Dinners." },
        { n: "03", title: "Club Dept 184", body: "Kultur nach Mitternacht: DJ-Sets, Live-Auftritte und immersive Nights vor industrieller Kulisse." },
      ],
      highlightsEyebrow: "Die Location auf einen Blick",
      highlightsTitle1: "Gebaut für",
      highlightsTitle2: "jedes Event",
      highlights: [
        { value: "3.000", suffix: " qm", label: "Innenfläche" },
        { value: "10.000", suffix: " qm", label: "Blick auf Park" },
        { value: "3", suffix: " in 1", label: "Konzepte unter einem Dach" },
      ],
      designedEyebrow: "Gestaltet zum Empfangen",
      designedP1:
        "Die Location ist darauf ausgelegt, eine Vielzahl von Veranstaltungen zu beherbergen — darunter Kunstausstellungen, Kultur- und Firmenveranstaltungen, Konzerte, DJ-Sets, Modenschauen, Märkte, Produktlaunches, Workshops, Fotoshootings, private Feiern sowie Business-Lunches und -Dinners.",
      designedP2:
        "Mit ihrem anpassungsfähigen Grundriss, hohen Decken und der unverwechselbaren Atmosphäre verkörpert Department 184 die Vision von Artful Events: vielseitige Orte zu schaffen, die sich mit jeder Veranstaltung weiterentwickeln und Besuchern neue Gründe geben, wiederzukommen.",
      caption: "Department 184 · Ehemaliges Sandvik-Industrieareal · Mailand",
    },
    faq: {
      eyebrow: "Hilfe benötigt",
      title: "Häufig gestellte Fragen",
      subtitle: "Alles Wichtige vor Ihrem Besuch einer Artful-Ausstellung.",
      items: [
        { q: "Wo befinden sich die Artful-Ausstellungen?", a: "Artful betreibt permanente und tourende Ausstellungen in ganz Europa und den USA — u. a. in Amsterdam, Barcelona, Brüssel, Krakau, Lissabon, Madrid, New York, Paris, Prag und Dortmund." },
        { q: "Muss ich Tickets im Voraus buchen?", a: "Wir empfehlen, Tickets vorab über die offizielle Buchungsseite des jeweiligen Standorts (siehe Ausstellungsseite) zu buchen, insbesondere an Wochenenden und Feiertagen." },
        { q: "Sind die Ausstellungen familienfreundlich?", a: "Ja — die meisten unserer Ausstellungen sind für alle Altersgruppen geeignet. Wir bieten Bildungsprogramme, Familienführungen und spezielle Workshops für Kinder an." },
        { q: "Darf ich in der Ausstellung fotografieren?", a: "Fotografieren für den privaten Gebrauch ist in der Regel willkommen. Stative, Blitz und kommerzielle Fotografie bedürfen einer vorherigen Genehmigung." },
        { q: "Bieten Sie Gruppen- oder Schulbesuche an?", a: "Selbstverständlich. Wir bieten geführte Touren und Bildungsprogramme für Gruppen, Schulen und Firmenbesuche an. Kontaktieren Sie uns für einen individuell geplanten Besuch." },
        { q: "Wie kann meine Marke oder Institution mit Artful zusammenarbeiten?", a: "Wir kooperieren mit Marken, Museen und Institutionen bei Co-Produktionen, Sponsoring und maßgeschneiderten Kulturprojekten. Schreiben Sie uns über die Kontaktseite, um ins Gespräch zu kommen." },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Schreiben Sie uns",
      subtitle:
        "Senden Sie uns eine Nachricht — Partnerschaften, Presse, Tickets oder ein anderes Anliegen.",
      formEyebrow: "Nachricht senden",
      formTitle: "Schreiben Sie uns",
      name: "Name *",
      email: "E-Mail *",
      phone: "Telefon",
      message: "Nachricht *",
      cta: "Nachricht senden",
      submitting: "Wird gesendet…",
      success: "Vielen Dank. Wir melden uns in Kürze.",
      infoEyebrow: "Besuchen Sie uns",
      infoTitle: "Unser Büro",
    },
    imprint: {
      eyebrow: "Rechtliches",
      title: "Impressum",
      subtitle: "Rechtliche Angaben zum Betreiber der Website.",
    },
    privacy: {
      eyebrow: "Rechtliches",
      title: "Datenschutzerklärung",
      subtitle: "Datenschutzhinweise.",
    },
  },
  footer: {
    columns: {
      about: "Über uns",
      support: "Service",
      follow: "Folgen Sie uns",
    },
    links: {
      about: "Über uns",
      imprint: "Impressum",
      privacy: "Datenschutz",
      contact: "Kontakt",
      faq: "FAQ",
    },
    tagline:
      "Transformative Kunsterlebnisse. Kuratierte Ausstellungen, Originalkonzepte und Partnerschaften in Europa, im Nahen Osten und in den USA.",
    closing: "Let's get Artful. Zeitgenössische Kunst, Weltklasse-Locations, nachhaltige Wirkung.",
    crafted: "Mit Leidenschaft gestaltet · Neuss, Deutschland",
    copyright: "Alle Rechte vorbehalten.",
  },
};

export const TRANSLATIONS = { en, de };
